import { type RouteRecordRaw } from "vue-router";

export const protectedRoutes: RouteRecordRaw[] = [
  {
    path: "family",
    name: "my-family",
    component: () => import("./pages/MyFamily.vue"),
    meta: { title: "menu.my_family", requiresAuth: true },
  },
  {
    path: "family/history",
    name: "family-history",
    component: () => import("./pages/FamilyHistory.vue"),
    meta: { title: "menu.family_history", requiresAuth: true },
  },
  {
    path: "family/fees",
    name: "family-fees",
    component: () => import("./pages/FamilyFeesPage.vue"),
    meta: { title: "menu.family_fees", requiresAuth: true },
  },
  {
    path: "family/emails",
    name: "family-mailbox",
    component: () => import("./pages/FamilyMailboxPage.vue"),
    meta: {
      title: "menu.family_mailbox",
      requiresAuth: true,
      requiresStaff: true,
    },
  },
  {
    path: "children",
    redirect: { name: "my-family" },
  },
  {
    path: "privacy",
    name: "my-privacy",
    component: () => import("./pages/Privacy.vue"),
    meta: { title: "menu.privacy", requiresAuth: true },
  },
  {
    path: "families",
    name: "families",
    component: () => import("./pages/FamiliesList.vue"),
    meta: { title: "menu.families", requiresAuth: true, requiresStaff: true },
  },
  {
    path: "families/:id",
    component: () => import("./pages/FamilyWorkspaceLayout.vue"),
    meta: {
      title: "menu.families",
      requiresAuth: true,
      requiresStaff: true,
      familyWorkspace: true,
      forceActiveMenu: "families",
    },
    children: [
      {
        path: "",
        name: "family-detail",
        component: () => import("./pages/FamilyDetail.vue"),
        meta: {
          title: "family.workspace_fiche",
          requiresAuth: true,
          requiresStaff: true,
          familyWorkspace: true,
          forceActiveMenu: "families",
        },
      },
      {
        path: "fees",
        name: "family-fees-detail",
        component: () => import("./pages/FamilyFeesPage.vue"),
        meta: {
          title: "menu.family_fees",
          requiresAuth: true,
          requiresStaff: true,
          familyWorkspace: true,
          forceActiveMenu: "families",
        },
      },
      {
        path: "activities",
        name: "family-activities",
        component: () => import("@/modules/Activities/pages/FamilyActivitiesPage.vue"),
        meta: {
          title: "menu.my_activities",
          requiresAuth: true,
          requiresStaff: true,
          familyWorkspace: true,
          forceActiveMenu: "families",
        },
      },
      {
        path: "documents",
        name: "family-documents",
        component: () => import("@/modules/Documents/pages/DocumentsPage.vue"),
        meta: {
          title: "menu.documents",
          requiresAuth: true,
          requiresStaff: true,
          familyWorkspace: true,
          forceActiveMenu: "families",
        },
      },
      {
        path: "privacy",
        name: "family-privacy",
        component: () => import("./pages/Privacy.vue"),
        meta: {
          title: "menu.privacy",
          requiresAuth: true,
          requiresStaff: true,
          familyWorkspace: true,
          forceActiveMenu: "families",
        },
      },
      {
        path: "history",
        name: "family-history-detail",
        component: () => import("./pages/FamilyHistory.vue"),
        meta: {
          title: "menu.family_history",
          requiresAuth: true,
          requiresStaff: true,
          familyWorkspace: true,
          forceActiveMenu: "families",
        },
      },
      {
        path: "emails",
        name: "family-mailbox-detail",
        component: () => import("./pages/FamilyMailboxPage.vue"),
        meta: {
          title: "menu.family_mailbox",
          requiresAuth: true,
          requiresStaff: true,
          familyWorkspace: true,
          forceActiveMenu: "families",
        },
      },
    ],
  },
];
